import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

let openModalCount = 0;
let previousBodyOverflow = '';

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'medium',
  closeLabel = 'Fermer',
  closeOnOverlayClick = true,
  overlayClassName = '',
  panelClassName = '',
  headerClassName = '',
  bodyClassName = '',
  footerClassName = '',
  closeButtonClassName = '',
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    if (openModalCount === 0) {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    openModalCount += 1;

    return () => {
      openModalCount = Math.max(0, openModalCount - 1);
      if (openModalCount === 0) {
        document.body.style.overflow = previousBodyOverflow;
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (closeOnOverlayClick) {
      onClose?.();
    }
  };

  const modal = (
    <div
      className={`ui-modal-overlay ${overlayClassName}`.trim()}
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className={`ui-modal-panel ui-modal-${size} ${panelClassName}`.trim()}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
      >
        {(title || onClose) && (
          <div className={`ui-modal-header ${headerClassName}`.trim()}>
            {title && <h2>{title}</h2>}
            {onClose && (
              <button
                type="button"
                className={`ui-modal-close ${closeButtonClassName}`.trim()}
                onClick={onClose}
                aria-label={closeLabel}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            )}
          </div>
        )}

        <div className={`ui-modal-body ${bodyClassName}`.trim()}>
          {children}
        </div>

        {footer && (
          <div className={`ui-modal-footer ${footerClassName}`.trim()}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default Modal;
